module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive-e631d3310c6c0d417b5204bb5e029236.png";